//#region src/scopes.ts
const SCOPES = {
	"org:read": "Read organization data",
	"project:write": "Write project data",
	"team:write": "Write team data",
	"event:write": "Write event data"
};

//#endregion
export { SCOPES };
//# sourceMappingURL=scopes.js.map